import { Stack } from "@mui/material";

const textBlockStyles = {
  // ? Is justifyContent not is redundant here?
  // As I understand it, justifyContent is used for horizontally aligned items,
  // But TextBlock is a Stack MUI component, the default axis of which is vertical...
  // Even where we do align things horizontally, we use Grid components, which have their own rules re. how items are placed
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "26px",
  paddingLeft: { xs: "16px", md: "96px" },
  paddingRight: { xs: "16px", md: "96px" },
};

// TODO Consider renaming this to ContentBlock
const TextBlock = ({ children }) => (
  <Stack sx={textBlockStyles}>{children}</Stack>
);
export default TextBlock;
